import { Component, OnInit } from '@angular/core';
import { LinkListItem } from 'sv-chemistry-ng-lib';
import { COMPANY_NAME } from 'src/app/shared/constants/misc';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sv-footer',
  templateUrl: './sv-footer.component.html',
  styleUrls: ['./sv-footer.component.scss']
})
export class SvFooterComponent implements OnInit {

  copyrightDate = new Date();
  links: LinkListItem[] = [];
  companyName = COMPANY_NAME;

  constructor() { }

  ngOnInit() {
    let view = ["About " + COMPANY_NAME, "Terms of Use", "Privacy Statement", "SVHarbor"];
    let urls = [environment.aboutUsUrl, environment.termsUrl, environment.privacyUrl, environment.svHarborExitUrl];
    if(view.length === urls.length){
      for(let i = 0, len = view.length; i < len; i++){
        this.links.push({
          name: view[i],
          href: urls[i],
          isRouterLink: false
        })
      }
    }
  }

  getYear() : number {
    return this.copyrightDate.getFullYear();
  }

}
